import React from 'react';
import { siteData } from '../data/mock';
import { Check, X, Target } from 'lucide-react';

const TargetAudienceSection = () => {
  return (
    <section id="target" className="section section-alt">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
              <Target size={16} className="text-blue-600" />
              <span className="text-sm font-medium text-blue-700">Público</span>
            </div>
            <h2 className="heading-2">{siteData.targetAudience.title}</h2>
          </div>

          {/* Two columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Ideal For */}
            <div className="bg-white rounded-2xl border border-blue-100 p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                  <Check size={22} className="text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-slate-800">Ideal para</h3>
              </div>
              <ul className="space-y-4">
                {siteData.targetAudience.idealFor.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check size={14} className="text-blue-600" />
                    </div>
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Not For */}
            <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center">
                  <X size={22} className="text-slate-500" />
                </div>
                <h3 className="text-lg font-semibold text-slate-800">Não é para</h3>
              </div>
              <ul className="space-y-4">
                {siteData.targetAudience.notFor.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <X size={14} className="text-slate-400" />
                    </div>
                    <span className="text-slate-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
